import { PageSEO } from "../pageSeo"
import {
  ElementEntry,
  Home,
  PageEntry,
  ResourceDetail,
  CaseStudies,
  Profiles,
} from "./index"

const sectionTypes = {
  home: Home,
  pages: PageEntry,
  resources: ResourceDetail,
  caseStudies: CaseStudies,
  profiles: Profiles,
}

export const Entry = ({ entry }) => {
  const SectionType = sectionTypes[entry.sectionHandle] || ElementEntry

  const { seomatic, ...rest } = entry

  return (
    <>
      <PageSEO seo={seomatic} />
      <SectionType entry={rest} />
    </>
  )
}
